/**
 * Work-order status-history actor mapping and display labels.
 *
 * Auto-rule transitions store `changedBy: null`. A left join to `users` then
 * returns `null` (not `undefined`) for name columns, so a check like
 * `firstName !== undefined` treats the missing user as present and the page
 * renders a blank name. Key the mapping on `changedBy` instead, and show
 * "Automatic" when there is no person — matching company status history.
 */

export type WorkOrderStatusChangedByUser = {
  firstName: string | null;
  lastName: string | null;
};

export function mapWorkOrderStatusChangedByUser(
  changedBy: string | null | undefined,
  names: { firstName: string | null; lastName: string | null },
): WorkOrderStatusChangedByUser | null {
  return changedBy ? { firstName: names.firstName, lastName: names.lastName } : null;
}

export function formatWorkOrderStatusChangedBy(
  changedByUser?: WorkOrderStatusChangedByUser | null,
): string {
  const name = changedByUser
    ? [changedByUser.firstName, changedByUser.lastName].filter(Boolean).join(" ").trim()
    : "";
  return name || "Automatic";
}
